var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#006633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7881 19.2107C27.2365 18.1327 28.7635 18.1327 29.2119 19.2107L31.2939 24.2164L36.6979 24.6496C37.8617 24.7429 38.3336 26.1952 37.4469 26.9547L33.3296 30.4817L34.5875 35.7551C34.8584 36.8908 33.623 37.7883 32.6267 37.1798L28 34.3538L23.3733 37.1798C22.377 37.7883 21.1416 36.8908 21.4125 35.7551L22.6704 30.4817L18.5531 26.9547C17.6665 26.1952 18.1383 24.7429 19.3021 24.6496L24.7062 24.2164L26.7881 19.2107Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.3897c2f506a3761fa2c295e81e1da7f3.svg";
export { ForwardRef as ReactComponent };